export type PublicSeoConfig = {
  title: string;
  description: string;
  noindex?: boolean;
};

/** Pathname (query'siz) → benzersiz title/description. Dinamik slug sayfaları burada yok. */
export const PUBLIC_SEO: Record<string, PublicSeoConfig> = {
  "/": {
    title: "Mersa Akademi | JSPS Sınavı Hazırlık Kursu",
    description:
      "Jandarma ve Sahil Güvenlik Personeli Sınavı (JSPS) hazırlık platformu. Canlı dersler, video eğitimler, PDF notlar ve deneme sınavları.",
  },
  "/egitimler": {
    title: "JSPS Eğitimleri | Mersa Akademi",
    description:
      "JSPS sınavına hazırlanan Jandarma ve Sahil Güvenlik personeli için canlı ders, video ve konu anlatım eğitimleri.",
  },
  "/jsps-sinavi": {
    title: "JSPS Sınavı (2026) Nedir? Başvuru, Konular ve Hazırlık Kılavuzu",
    description:
      "Jandarma ve Sahil Güvenlik Personeli Sınavı (JSPS) nedir, kimler girebilir, 2026 başvuru şartları ve sınav konuları nelerdir? En kapsamlı JSPS rehberi.",
  },
  "/paketler": {
    title: "JSPS Hazırlık Paketleri | Canlı, Video ve PDF | Mersa Akademi",
    description:
      "JSPS canlı ders, video kayıt ve PDF paketlerini karşılaştırın. Sınava kadar erişim, soru bankası ve deneme sınavları.",
  },
  "/kitaplar": {
    title: "JSPS Kitapları ve Soru Bankaları | Mersa Akademi",
    description:
      "JSPS müşterek ve branş konu anlatımları, soru bankaları ve dijital kitaplar. Mersa Akademi yayınları.",
  },
  "/ucretsiz-quizler": {
    title: "JSPS Denemeleri | Mersa Akademi",
    description:
      "JSPS sınavına denemelerle hazırlanın. Mevzuat, Türkçe, İnkılap Tarihi ve güncel sorular.",
  },
  "/blog": {
    title: "JSPS Blog ve Duyurular | Mersa Akademi",
    description:
      "JSPS sınav duyuruları, mevzuat güncellemeleri, astsubaylığa geçiş ve hazırlık rehberleri.",
  },
  "/blog/jsps-cikmis-sorular": {
    title: "JSPS Çıkmış Sorular: Sınav Sorularına Nasıl Ulaşılır?",
    description:
      "JSPS çıkmış sınav soruları ve cevapları nereden bulunur? Jandarma branş ve müşterek sınavlarına benzer denemeler çözerek sınava nasıl hazırlanılır?",
  },
  "/blog/jsps-uzman-cavus-astsubay-gecis-ve-branslar": {
    title: "JSPS Uzman Çavuş ve Astsubay Geçiş Şartları, Branşlar ve Başvuru Ekranı",
    description:
      "Jsps uzman çavuş ve Jsps astsubay geçiş şartları, Jsps branşları ile Jsps başvuru ekranı adımları. 2026 JSPS hazırlık rehberi.",
  },
  "/hakkimizda": {
    title: "Hakkımızda | Mersa Akademi — JSPS Uzman Eğitim Platformu",
    description:
      "Yılların tecrübesi, jandarma personeline özel uzman eğitmen kadrosu ve güncel mevzuata tam hakimiyetle JSPS hazırlığı. Mersa Akademi'yi tanıyın.",
  },
  "/iletisim": {
    title: "İletişim | Mersa Akademi",
    description:
      "JSPS hazırlık, paketler ve kayıt hakkında Mersa Akademi ile iletişime geçin. Telefon, e-posta ve WhatsApp.",
  },
  "/kvkk-aydinlatma": {
    title: "KVKK Aydınlatma Metni | Mersa Akademi",
    description: "Mersa Akademi 6698 sayılı KVKK kapsamındaki aydınlatma metni ve kişisel verilerin işlenmesi.",
  },
  "/mesafeli-satis-sozlesmesi": {
    title: "Mesafeli Satış Sözleşmesi | Mersa Akademi",
    description: "Mersa Akademi çevrim içi eğitim ve kitap satışlarına ilişkin mesafeli satış sözleşmesi.",
  },
  "/iptal-iade-kosullari": {
    title: "İptal ve İade Koşulları | Mersa Akademi",
    description: "Mersa Akademi dijital eğitim paketleri ve fiziki kitaplar için iptal ve iade koşulları.",
  },
  "/gizlilik-politikasi": {
    title: "Gizlilik Politikası | Mersa Akademi",
    description: "Mersa Akademi gizlilik politikası: toplanan veriler, çerezler ve üçüncü taraf hizmetler.",
  },
  "/cerez-politikasi": {
    title: "Çerez Politikası | Mersa Akademi",
    description: "Mersa Akademi sitesinde kullanılan çerez türleri, amaçları ve yönetim tercihleri.",
  },
  "/sepet": {
    title: "Sepet | Mersa Akademi",
    description: "Mersa Akademi alışveriş sepeti.",
    noindex: true,
  },
  "/checkout": {
    title: "Ödeme | Mersa Akademi",
    description: "Mersa Akademi güvenli ödeme sayfası.",
    noindex: true,
  },
  "/odeme-basarili": {
    title: "Ödeme Başarılı | Mersa Akademi",
    description: "Siparişiniz alındı.",
    noindex: true,
  },
  "/odeme-basarisiz": {
    title: "Ödeme Başarısız | Mersa Akademi",
    description: "Ödeme tamamlanamadı.",
    noindex: true,
  },
  "/giris": {
    title: "Giriş Yap | Mersa Akademi",
    description: "Mersa Akademi öğrenci paneline giriş.",
    noindex: true,
  },
  "/kayit": {
    title: "Kayıt Ol | Mersa Akademi",
    description: "Mersa Akademi'ye kayıt olun, JSPS eğitimlerinize başlayın.",
    noindex: true,
  },
  "/sifremi-unuttum": {
    title: "Şifremi Unuttum | Mersa Akademi",
    description: "Mersa Akademi hesap şifresi sıfırlama.",
    noindex: true,
  },
};

export const DEFAULT_SEO: PublicSeoConfig = {
  title: "Mersa Akademi | JSPS Sınav Hazırlığı",
  description:
    "Jandarma ve Sahil Güvenlik Personeli Sınavı (JSPS) hazırlık platformu. Canlı dersler, video eğitimler ve denemeler.",
};
